import React,  {useEffect } from 'react';
import { Box, Text } from '@chakra-ui/react';
import Warning from 'icons/images/warning';
import { useSession } from 'context/SessionContext';

const NotFoundPage: React.FC = () => {
  const { setData } = useSession();

  useEffect(() => {
    setData({});
    sessionStorage.clear(); 
  }, []);

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      minH="calc(100vh - 100px)"
      textAlign="center"
      p="0 10px"
    >
      <Warning />
      <Text as="h1" fontSize={["30px", "40px"]} mt={3} mb={6} color="brand.primary">
        Esta página já não existe ou foi alterada.
      </Text>
      <Text fontSize="16px" color="brand.fontColors.primary">
        Para encontrar o que procura, tente a nossa Pesquisa.
        <br /> Em alternativa, aceda à{' '}
        <a href="https://www.ocidental.pt/" target="_blank">
          homepage
        </a>{' '}
        ou{' '}
          clique
        {' '}
        em retroceder no browser.
      </Text>
      <Text color="brand.primary" fontSize={['100px', "150px"]} lineHeight="125%">
        404
      </Text>
    </Box>
  );
};

export default NotFoundPage;
